'use strict';

wbApp.factory('invoiceSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {

        var Invoice = $resource('/Api/Invoices/:id', {}, {
            'getByID': { method: 'GET', isArray: false, url: 'Api/Invoices/GetByID' },
            'getFinanceSummary': { method: 'GET', isArray: true, url: '/Api/Invoices/GetFinanceSummary', params: {} },
            'getPaymentDetailsByStudent': { method: 'GET', isArray: false, url: '/Api/Invoices/GetPaymentDetailsByStudent', params: {} },
            'getPaymentDetailsByInvoice': { method: 'GET', isArray: false, url: '/Api/Invoices/GetPaymentDetailsByInvoice', params: {} },
            'getInvoiceEvidenceBySemester': { method: 'GET', isArray: true, url: '/Api/Invoices/GetInvoiceEvidenceBySemester', params: {} },
            'getInvoiceEvidenceByDateRange': { method: 'GET', isArray: true, url: '/Api/Invoices/GetInvoiceEvidenceByDateRange', params: {} },
            'getInvoiceEvidenceByUser': { method: 'GET', isArray: true, url: '/Api/Invoices/GetInvoiceEvidenceByUser', params: {} },
            'getInvoiceEvidenceByActivityAndStudent': { method: 'GET', isArray: true, url: '/Api/Invoices/GetInvoiceEvidenceByActivityAndStudent', params: {} },
            'getInvoiceEvidenceByInvoiceID': { methos: 'GET', isArray: false, url: '/Api/Invoices/GetInvoiceEvidenceByInvoiceID', params: {} },
            'getLatestByCourseRegistration': { methos: 'GET', isArray: false, url: '/Api/Invoices/GetLatestByCourseRegistration', params: {} },
            'delete': { method: 'POST', url: '/Api/Invoices/Delete' },
            'getStormwareInvoiceExport': { method: 'POST', url: '/Api/Invoices/GetStormwareInvoiceExport' },
            'getMoneyS3InvoiceExport': { method: 'POST', url: '/Api/Invoices/GetMoneyS3InvoiceExport' },
            'getCsvInvoiceExport': { method: 'POST', url: '/Api/Invoices/GetCsvInvoiceExport' },
        });

        function getByID(invoiceID) {
            return repositorySvc.customGet('getByID', Invoice, {
                invoiceID: invoiceID
            });
        }

        function getFinanceSummary() {
            return Invoice.getFinanceSummary({ });
        }

        function getPaymentDetailsByStudent(invoiceForType, studentID) {
            return repositorySvc.customGet('getPaymentDetailsByStudent', Invoice, {
                invoiceForType: invoiceForType,
                studentID: studentID
            });
        }

        function getInvoiceEvidenceByInvoiceID(invoiceID) {
            return repositorySvc.customGet('getInvoiceEvidenceByInvoiceID', Invoice, {
                invoiceID: invoiceID
            });
        }

        function getLatestByCourseRegistration(courseRegistrationID) {
            return repositorySvc.customGet('getLatestByCourseRegistration', Invoice, {
                courseRegistrationID: courseRegistrationID
            });
        }

        function getPaymentDetailsByInvoice(invoiceForType, invoiceID) {
            return repositorySvc.customGet('getPaymentDetailsByInvoice', Invoice, {
                invoiceForType: invoiceForType,
                invoiceID: invoiceID
            });
        }

        function getInvoiceEvidenceBySemester(semesterID) {
            var deferred = $q.defer();

            var invoices = [];
            invoices.$promise = deferred.promise;

            repositorySvc.customGet('getInvoiceEvidenceBySemester', Invoice, {
                semesterID: semesterID
            }).$promise.then(
                function (data) {
                    angular.forEach(data, function (i) {
                        i.notLatest = !i.latest;
                    });
                    invoices.push.apply(invoices, data);
                    deferred.resolve(invoices);
                }, function (reason) {
                    deferred.reject(reason);
                });

            return invoices;
        }

        function getInvoiceEvidenceByDateRange(fromDate, toDate) {
            var deferred = $q.defer();

            var from = moment(fromDate).startOf('day').toDate();
            var to = moment(toDate).endOf('day').toDate();

            var invoices = [];
            invoices.$promise = deferred.promise;

            repositorySvc.customGet('getInvoiceEvidenceByDateRange', Invoice, {
                fromDate: from,
                toDate: to
            }).$promise.then(
                function (data) {
                    angular.forEach(data, function (i) {
                        i.notLatest = !i.latest;
                    });
                    invoices.push.apply(invoices, data);
                    deferred.resolve(invoices);
                }, function (reason) {
                    deferred.reject(reason);
                });

            return invoices;
        }

        function getInvoiceEvidenceByUserAsync(userID) {
            var deferred = $q.defer();

            var invoices = [];
            invoices.$promise = deferred.promise;

            repositorySvc.customGet('getInvoiceEvidenceByUser', Invoice, {
                userID: userID
            }).$promise.then(
                function (data) {
                    angular.forEach(data, function (i) {
                        i.notLatest = !i.latest;
                    });
                    invoices.push.apply(invoices, data);
                    deferred.resolve(invoices);
                }, function (reason) {
                    deferred.reject(reason);
                });

            return invoices;
        }

        function getInvoiceEvidenceByActivityAndStudent(activityID, studentID) {
            var deferred = $q.defer();

            var invoices = [];
            invoices.$promise = deferred.promise;

            repositorySvc.customGet('getInvoiceEvidenceByActivityAndStudent', Invoice, {
                activityID: activityID,
                studentID: studentID
            }).$promise.then(
                function (data) {
                    angular.forEach(data, function (i) {
                        i.notLatest = !i.latest;
                    });
                    invoices.push.apply(invoices, data);
                    deferred.resolve(invoices);
                }, function (reason) {
                    deferred.reject(reason);
                });

            return invoices;
        }

        function remove(data, successCallback, errorCallback) {
            repositorySvc.remove(
                Invoice,              // $resource
                null,                 // collection
                data,                 // entity
                successCallback,
                errorCallback,
                null,
                'invoiceID');
        }


        function getStormwareInvoiceExport(accountingBookID, invoiceIDs, success, error) {
            return repositorySvc.customPost('getStormwareInvoiceExport', Invoice, {
                accountingBookID: accountingBookID,
                invoiceIDs: invoiceIDs
            },
            success,
            error);
        }


        function getMoneyS3InvoiceExport(accountingBookID, invoiceIDs, exportAsInvoices, success, error) {
            return repositorySvc.customPost('getMoneyS3InvoiceExport', Invoice, {
                accountingBookID: accountingBookID,
                invoiceIDs: invoiceIDs, 
                exportAsInvoices: !!exportAsInvoices
            },
            success,
            error);
        }

        function getCsvInvoiceExport(accountingBookID, invoiceIDs, success, error) {
            return repositorySvc.customPost('getCsvInvoiceExport', Invoice, {
                    accountingBookID: accountingBookID,
                    invoiceIDs: invoiceIDs
                },
                success,
                error);
        }

        return {
            getByID: getByID,
            getFinanceSummary: getFinanceSummary,
            getPaymentDetailsByStudent: getPaymentDetailsByStudent,
            getPaymentDetailsByInvoice: getPaymentDetailsByInvoice,
            getInvoiceEvidenceBySemester: getInvoiceEvidenceBySemester,
            getInvoiceEvidenceByDateRange: getInvoiceEvidenceByDateRange,
            getInvoiceEvidenceByUserAsync: getInvoiceEvidenceByUserAsync,
            getInvoiceEvidenceByActivityAndStudent: getInvoiceEvidenceByActivityAndStudent,
            getInvoiceEvidenceByInvoiceID: getInvoiceEvidenceByInvoiceID,
            getLatestByCourseRegistration: getLatestByCourseRegistration,
            remove: remove,
            getStormwareInvoiceExport: getStormwareInvoiceExport,
            getMoneyS3InvoiceExport: getMoneyS3InvoiceExport,
            getCsvInvoiceExport: getCsvInvoiceExport
        }

    }]);